import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  index(params) {
    const url = apiRoutes.realEstateAgentFavoriteLoanOfficersPath();

    return FetchHelpers.get(url, params);
  },
  create(params) {
    const url = apiRoutes.realEstateAgentFavoriteLoanOfficersPath();

    return FetchHelpers.post(url, params);
  },
  destroy(id) {
    const url = apiRoutes.realEstateAgentFavoriteLoanOfficerPath(id);

    return FetchHelpers.delete(url);
  },
  update(id, params) {
    const url = apiRoutes.realEstateAgentLoanOfficerMembershipPath(id);

    return FetchHelpers.put(url, params);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/realEstateAgent/FavoriteLoanOfficersRepository.js